import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import './Buttons.css';

const buttons = (props) => {

    let inputElement = null;
    let componentType = props.buttonType

    switch (componentType) {
        case ('primary'):
            inputElement = <Button 
            variant="contained"
            onClick= {props.buttonAction}
            color="primary"
            disabled={props.disabled}
            className={ props.classInput + " primary-color"}>
                {props.buttontext}
          </Button>
            break;
        case ('secondary'):
            inputElement = <Button
             variant="outlined"
             onClick= {props.buttonAction}
             color="primary"
             disabled={props.disabled}
             className= { props.classInput + " secondary-color"}>
                {props.buttontext}
          </Button>
          break;
        case ('icon-btn'):
            inputElement = <Button
             variant="outlined"
             onClick= {props.buttonAction}
             color="primary"
             startIcon={props.icon}
             disabled={props.disabled}
             className= { props.classInput }>
                {props.buttontext}
          </Button>
          break;
          
        default:

    }


    return (
        <Fragment>
            {inputElement}
        </Fragment>

    )

};

export default buttons;